// SAL6010_R01 컨테이너
// - 액션바/검색/목록/정보/상세 테이블을 배치하고 상호작용을 연결합니다.
// - 좌우 분할 리사이즈와 로딩 오버레이 등 페이지 전반 제어를 담당합니다.
import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL6010_R01 } from "./Content_SAL6010_R01";
import { Info_SAL6010_R01 } from "./Info_SAL6010_R01";
import { DetailTable_SAL6010_R01 } from "./DetailTable_SAL6010_R01";
import { SearchSection_SAL6010_R01 } from "./SearchSection_SAL6010_R01";
import { useSAL6010_R01Store } from "./Store_SAL6010_R01";
import { Table_SAL6010_R01 } from "./Table_SAL6010_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL6010_R01DetailDto, SAL6010_R01Dto, SAL6010_R01HeaderDto } from "./Dto_SAL6010_R01";


export const Container_SAL6010_R01 = () => {

	const { 
		allCount,
		initData,
		SAL6010_R01List,
		SAL6010_R01DetailList,
	} = useSAL6010_R01Store();

	const { tabList, setMessage, SAL6020_SAL6010NavigationData } = useUiuxStore();

	// 좌우 분할 리사이즈 설정 (목록/정보 영역 비율 저장)
	const RESIZER = {
		code: 'SAL6010_R01',
		type: 'width',
		storageKey: 'SAL6010_R01-split-width',
		min: 5,
		max: 80,
		default: 37
	} as const;
	const gridRef = useRef<AgGridReact<SAL6010_R01HeaderDto>>(null); 
	const detailGridRef = useRef<AgGridReact<SAL6010_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	
	// 마우스 드래그 기반 분할바 리사이즈 핸들러 바인딩
	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'SAL6010_R01',
		type: 'height',
		storageKey: 'SAL6010_R01-info-split-height',
		min: 5,
		max: 80,
		default: 47
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	// 비즈니스 로직/핸들러 묶음 (조회/저장/엑셀/인쇄/수주처리 등)
	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultSAL6010_R01HeaderRow,
		defaultSAL6010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleOrderProcessClick,
	} = Content_SAL6010_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	useEffect(() => { 
		if (SAL6010_R01List.length === 0 && SAL6010_R01DetailList.length === 0 && !SAL6020_SAL6010NavigationData) { handleCreateClick(); }
	}, [SAL6010_R01List, SAL6010_R01DetailList, handleCreateClick, SAL6020_SAL6010NavigationData]);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_SAL6010_R01 />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_SAL6010_R01 
					gridRef={gridRef}
					defaultSAL6010_R01HeaderRow={defaultSAL6010_R01HeaderRow()}
					handleCreateClick={handleCreateClick} 
				/>
			</div>
			{/* 리사이즈 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이즈"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_SAL6010_R01 
						editable={false} 
						onOrderProcessClick={handleOrderProcessClick} 
						defaultSAL6010_R01HeaderRow={defaultSAL6010_R01HeaderRow()}
					/>
				</div>
				{/* 리사이즈 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }} className="pb-[12px]">
					<DetailTable_SAL6010_R01 gridRef={detailGridRef} defaultSAL6010_R01DetailRow={defaultSAL6010_R01DetailRow()} />
				</div>
			</div>
		</div>
		<Message />
	</div>
}
